import { CommonService } from './../../../services/common/common.service';
// Library Class
import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, HostListener, OnDestroy, ViewEncapsulation, Renderer2 } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AbstractControl, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatCalendarCellCssClasses, MatCalendar } from '@angular/material/datepicker';
import { NgbDateStruct, NgbCalendar, NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ErrorStateMatcher } from '@angular/material/core';
import * as $ from 'jquery';

// Service Class
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { CppService } from './../../../services/cpp/cpp.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { CppAddProductSliderModelService } from '../cpp-common-components/cpp-add-product/cpp-add-product-slider-model.service';
import { SeedReturnService } from './../../../services/seed/seed-return.service';


// Class
import { MasterConstants } from '../../../common/constants/master-constants';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';
import { DialogComponent } from '../../../common/components/dialog/dialog.component';
import { MatDatepicker } from '@angular/material/datepicker';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-cpp-create-order',
  templateUrl: './cpp-create-order.component.html',
  styleUrls: ['./cpp-create-order.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class CppCreateOrderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('calendar') matcalendar: MatCalendar<Date>;
  @ViewChild('picker') datepicker: MatDatepicker<any>;
  @ViewChild('datepickerFooter') datepickerFooter: ElementRef;
  @ViewChild('calendarContainer') calendarContainer!: ElementRef;
  private subscription = new Array<Subscription>();

  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 1;

  // Drop Down Lists Data
  shipToFacilityList: any[];
  soldToFacility: any[];
  deliverToList: any[];
  ddlInstructionTypeList: any[];
  // Header selected values
  shipToAccount: number;
  shipToAccountName: string;
  deliverToAccount: number;
  soldToAccount: number;
  instructionType: string;
  deliveryDateReason: string;
  dynamicDisclaimerMessage: string;
  headerCompany = MasterConstants.US_COMPANYCODE;
  specialInstructionText: string;
  purchaseOrder: string;
  bypassDuplicatePOCheck = false;
  isVACartData = false;

  cppProductItemsDataSource: any;
  cppOriginalProductItemsDataSource: any;
  itemNoList: any = [];
  // Item keys passed from the AI CPP chatbot via local storage ('temData').
  aiCartItemKeys: string[] = [];
  displayedColumns: string[]  = ['checkbox', 'product', 'flashmsg', 'viewDetail', 'quantity', 'orderUOM', 'totalGallon', 'deliveryDate', 'deliveryDateReason'];
  instructionTypeList: Object;
  allChecked = false;
  isCustomerPickup = false;
  isSaveOrderDraftEnable = false;
  isPlaceOrderEnable = false;
  isAddProductEnable = false;
  filterArray = [];
  showTabs = false;
  tabNode: string;
  editToolKit = false;
  datemodel: NgbDateStruct;
  requestDatemodel: NgbDateStruct;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) == 7;
  isHoliday = (date: NgbDate) => this.getIsHoliday(date);
  isRequestHoliday = (date: NgbDate, data: any) => this.getIsRequestHoliday(date, data);
  requestDateType = (date: NgbDate, data: any) => this.getRequestDateType(date, data);
  selectedWeekdays = [];
  // done to remove prod errors
  alphaNumericPattern: any = /^[A-Za-z0-9]+$/;
  alphaNumericPatternWithSpace: any = /^[A-Za-z0-9 ]+$/;
  isCustPONotValid = false;
  shipToDataLoading: any;
  soldToDataLoading: any;
  deliverToDataLoading: any;
  deliverToAnotherLocation = false;
  disablecheckbox: any;
  selectedCount = 0;
  isSearchClicked: any;
  isReleased: any;
  index: any;
  enable: any;
  webOrderNumber = 0;
  orderId = 0;
  isEditMode = false;
  hasChangeAdded = false;
  dateFilter: any;
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  readOnlyAccess = false;
  userMenuAccessList: any;
  date = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  maxDateBulk = new Date();
  isAccontSDM = false;
  itemsIdsWithSDM: any;
  reasonList: any[];
  sdmSystemGeneratedDate?: Date = null;
  isWeekendForNonSDM = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;
  matcher = new InputErrorStateMatcher(this.isNotValid);
  plAccess = false;
  disclaimerMessage: string;
  bulkItemNumberOfLine: any;
  bulkItemTimeFrame: any;
  repackAgreement: string;
  isShowBulkContactDetails = false;
  blkContactName: string;
  blkContactNumber: string;
  phonePattern = /^(\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  configurationMessage: any[];
  isShowNonSubEmail = true;
  cppDeliveryInstructionList: any;
  cppBulkContactInfo: string;
  lastBulkContactSearched = '';
  inputBulkContactName$ = new Subject<string | null>();
  pkgContactName: string;
  pkgContactNumber: string;
  cppPackagedContactInfo: string;
  isShowPackagedContactDetails: boolean = false;
  deliveryInstructionsCodeList: any = [{ id: 'PJK', value: 'Pallet Jack Required' }, { id: 'DRA', value: 'Driver Required Assistance' }, { id: 'UNMAN', value: 'Unmanned Location' }];
  cppDeliveryInstructionCode: Array<string> = [];
  cppPackagedDeliveryInstructionList: any;
  lastPackagedContactSearched: string = '';
  inputPackagedContactName$ = new Subject<string | null>();
  lastUpdatedInv?: Date = null;
  isMobileResolution: boolean = false;
  shouldShowSurveyMessage: boolean = false;
  evolveSurveyUrl: string = '';
  userId: string ;


  constructor(
    private router: Router,
    private calendar: NgbCalendar,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    private cppService: CppService,
    private matDialog: MatDialog,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private commonService: CommonService,
    private renderer: Renderer2,
    private cppAddProductSliderModelService: CppAddProductSliderModelService,
    private localStorageService: LocalStorageService,
    private datePipe: DatePipe,
    private seedReturnService: SeedReturnService) {
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }


  ngOnInit() {
    this.isMobileResolution = window.innerWidth <= 768;
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.GetDisclaimerMessage();
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));     
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        this.userId = data.resultData[0].userId;       
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isShowNonSubEmail = true;
        }

        // this.accountEmail = data.resultData[0].emailId;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
        this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
      }
    }

    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.configurationMessage = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE));
      if (this.configurationMessage.filter(x => x.id === 'BULK_ITEM_NUMBER_OF_LINES').length > 0) {
        this.bulkItemNumberOfLine = this.configurationMessage.filter(x => x.id === 'BULK_ITEM_NUMBER_OF_LINES')[0].value;
      }
      else {
        this.bulkItemNumberOfLine = 10;
      }
      if (this.configurationMessage.filter(x => x.id === 'BULK_ITEM_TIME_FRAME').length > 0) {
        this.bulkItemTimeFrame = this.configurationMessage.filter(x => x.id === 'BULK_ITEM_TIME_FRAME')[0].value;
      }
      else {
        this.bulkItemTimeFrame = 12;
      }
      this.maxDateBulk = new Date(this.date.setMonth(parseInt(this.bulkItemTimeFrame)));
    }

    this.hasChangeAdded = false;
    this.loadMasterData();
    this.cppProductItemsDataSource = new MatTableDataSource([]);
    this.cppOriginalProductItemsDataSource = this.cppProductItemsDataSource.data;
    this.disablecheckbox = true;
    this.subscription.push(this.cppService.cppOrderId.subscribe(x => {
      if (x && x != 0) {
        this.orderId = x;
        this.isEditMode = true;
        this.isAddProductEnable = true;
        this.getOrderDetails(0, x);
        this.enablePlaceOrderAndSaveOrderDraft();
      }
    }));

    this.subscription.push(this.cppAddProductSliderModelService.cppModelData.subscribe(x => {
      if (x != null && x.selectedProductList) {
        x.selectedProductList.forEach(x => {
          x.orderQty = x.quantity;
          x.totalGallon = x.gallonConvFactor == null ? null : x.gallonConvFactor;
        });
        this.formatNewAddedData(x.selectedProductList);
        this.enablePlaceOrderAndSaveOrderDraft();
      }
    }));

    this.validateDateFilter();
    this.errorMsgs = new Array();

    this.inputBulkContactName$.subscribe((newTerm) => {
      if (newTerm) {
        this.lastBulkContactSearched = newTerm;
      }
    });

    this.inputPackagedContactName$.subscribe((newTerm) => {
      if (newTerm) {
        this.lastPackagedContactSearched = newTerm;
      }
    });

    this.checkSurveyMessageEligibilty();
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;// .getDate();

      return calendarDate >= currentDate;
    };
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    if (window.innerWidth > 767) {
      const windowHeight = window.innerHeight - 145;
      $('.createCPPOuter').css('height', windowHeight + 'px');
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
    this.isMobileResolution = window.innerWidth <= 768;
  }

  // Detect clicks on the document
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (
      this.calendarContainer &&
      !this.calendarContainer.nativeElement.contains(event.target)
    ) {
      if (this.cppProductItemsDataSource && this.cppProductItemsDataSource.data) {
        this.cppProductItemsDataSource.data.forEach(x => {
          if (x.openDatepicker) {
            x.openDatepicker = false;
          }
        })
      }
    }
  }

  checkSurveyMessageEligibilty() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReturnService.checkSurveyMessageEligibilty().subscribe((result) => {
      this.shouldShowSurveyMessage = result.shouldShowSurveyMessage;
      this.evolveSurveyUrl = result.surveyUrl;
       this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Formate Data from Add Product Slider Model
  formatNewAddedData(productList: any[]) {
    const orderList = [];
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    let rowId = 0;
    this.cppProductItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });
    productList.forEach(x => {
      rowId = rowId + 1;
      const duplicateData = orderList.find(y => y.itemId == x.itemId);
      if (duplicateData == undefined) {
        const newRow = {
          rowId: rowId,
          isSelected: false,
          isProductDetailDisplayed: false,
          itemId: x.itemId,
          itemNumber: x.itemNumber,
          itemDescription: x.itemDescription,
          itemVendorName: x.itemVendorName,
          packageSize: x.packageSize,
          gtin: x.gtin,
          activeIngredient: x.activeIngredient,
          productSegment: x.productSegment,
          productLine: x.productLine,
          palletQuantity: x.palletQuantity,
          programName: x.programName,
          bulkPackaged: x.bulkPackaged,
          vendedProprietary: x.vendedProprietary,
          xrefCheckBK: x.xrefCheckBK,
          itemFlashMsg: x.itemFlashMsg,
          restrictedUse: x.restrictedUse,
          returnable: x.returnable,
          isRepackItem: x.isRepackItem,
          uom: x.uom,
          price: x.price,
          pricePerUnit: x.pricePerUnit,
          priceCurrency: x.priceCurrency,
          pricingUnitOfMeasure: x.pricingUnitOfMeasure,
          pricingPackageSize: x.pricingPackageSize,
          isFavorite: x.isFavorite,
          deliveryDate: x.bulkPackaged == 'BULK' ? null : x.desiredDelDate,
          defaultDeliveryDate: x.defaultDelDate,
          quantity: x.orderQty,
          totalGallon: x.totalGallon,
          gallonConvFactor: x.gallonConvFactor,
          lineErrors: { 'rowId': rowId, 'errors': [] },
          orderConvFactor: x.uom == 'IB' ? x.orderConvFactor : 1,
          modifiedOrderedQuantity: x.uom == 'IB' ? x.orderConvFactor : 1,
          modifiedOrderingUOM: x.uom == 'IB' ? x.orderUOM : x.uom,
          modifiedUOMConverted: x.uom == 'IB' ? x.webStandardOrderUOM : x.webStandardUOM,
          pricingQuantity: x.pricingUnitConvFactor,
          pricingUnitConvFactor: x.pricingUnitConvFactor,
          allowDecimal: x.allowDecimal,
          warningMessage: x.warningMessage,
          isLineSDM: x.isLineSDM,
          deliveryDateReason: x.deliveryDateChangeReason,
          yourPrice: x.yourPrice,
          paymentTerms: x.paymentTerms,
          isBulkSetup: x.bulkPackaged == 'BULK' ? true : false,
          isBulkRowExceed: false,
          repackAgreement: x.repackAgreement,
          itemFlashMsgDesc: x.itemFlashMsgDesc,
          inventoryTag: x.inventoryTag,
          inventoryHover: x.inventoryHover,
          inventoryStopLightClass: x.inventoryStopLightClass,
          defaultChildItemId: x.defaultChildItemId,
          isBIO: x.isBIO,
          poundConvFactor: x.poundConvFactor,
          isDryItem: x.isDryItem,
          totalGlnPnd: x.isDryItem
            ? (x.poundConvFactor > 0 ? x.poundConvFactor : (x.totalGallon > 0 ? x.totalGallon : null))
            : x.totalGallon,
          totalCalQtyGlnPnd: x.isDryItem
            ? (x.poundConvFactor > 0 ? x.poundConvFactor : (x.totalGallon > 0 ? x.totalGallon : null))
            : x.totalGallon,
          measurementGlnPnd: x.isDryItem
            ? (x.poundConvFactor > 0 ? 'LB' : (x.totalGallon > 0 ? 'GA' : null))
            : (x.totalGallon > 0 ? 'GA' : null),
          setDefMinQty: x.setDefMinQty
        };

        if (newRow.totalCalQtyGlnPnd == null || newRow.quantity == '' || newRow.quantity == 0) {
          newRow.totalGlnPnd = null;
        }
        else {
          newRow.totalGlnPnd = (+newRow.totalCalQtyGlnPnd * +(newRow.quantity));
        }

        this.qtyCount = this.qtyCount + x.orderQty;
        this.totalPrice = this.totalPrice + (x.orderQty * x.price);
        orderList.splice(orderList.length, 0, newRow);
      }
      else {
        duplicateData.quantity += +x.orderQty;
      }
    });
    
    this.filteredDataCount = orderList.length;
    this.cppProductItemsDataSource.data = orderList;
    this.cppOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.isShowBulkContactDetails = this.cppOriginalProductItemsDataSource.some(x => x.bulkPackaged.toLowerCase() == 'BULK'.toLowerCase());
    this.isShowPackagedContactDetails = this.cppOriginalProductItemsDataSource.some(x => x.bulkPackaged.toLowerCase() == 'PACKAGED'.toLowerCase());
    this.validateDeliveryDateFilter();

    if (this.cppProductItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }

    this.cppProductItemsDataSource.data.map(x => {
      x['openDatepicker'] = false;
      x['deliveryDate'] = this.datePipe.transform(x.deliveryDate, 'MM/dd/yyyy');
      this.quantityTextChange(x);
    });
  }

  // Formate Data for edit a draft order
  formatEditOrderData(productList: any[]) {
    const orderList = [];
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    let rowId = 0;
    this.cppProductItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });
    productList.forEach(x => {
      rowId = rowId + 1;
      const newRow = {
        rowId: rowId,
        isSelected: false,
        isProductDetailDisplayed: false,
        itemId: x.itemId,
        itemNumber: x.itemNumber,
        itemDescription: x.itemDescription,
        itemVendorName: x.itemVendorName,
        packageSize: x.packageSize,
        gtin: x.gtin,
        activeIngredient: x.activeIngredient,
        productSegment: x.productSegment,
        productLine: x.productLine,
        palletQuantity: x.palletQuantity,
        programName: x.programName,
        bulkPackaged: x.bulkPackaged,
        vendedProprietary: x.vendedProprietary,
        xrefCheckBK: x.xrefCheckBK,
        itemFlashMsg: x.itemFlashMsg,
        restrictedUse: x.restrictedUse,
        returnable: x.returnable,
        uom: x.uom,
        price: x.price,
        pricePerUnit: x.pricePerUnit,
        priceCurrency: x.priceCurrency,
        pricingUnitOfMeasure: x.pricingUnitOfMeasure,
        pricingPackageSize: x.pricingPackageSize,
        isFavorite: x.isFavorite,
        deliveryDate: x.defaultDelDate, // set system calculated date instead of save date as per new logic as old dates are not valid
        defaultDeliveryDate: x.defaultDelDate,
        quantity: x.allowDecimal ? x.orderQty.toFixed(this.commonService.countDecimals(x.orderQty)) : x.orderQty,
        lineErrors: { 'rowId': rowId, 'errors': [] },
        orderConvFactor: x.uom == 'IB' ? x.orderConvFactor : 1,
        modifiedOrderingUOM: x.modifiedOrderingUOM,
        modifiedUOMConverted: x.modifiedUOMConverted,
        pricingQuantity: x.pricingUnitConvFactor,
        pricingUnitConvFactor: x.pricingUnitConvFactor,
        allowDecimal: x.allowDecimal,
        warningMessage: x.warningMessage,
        isLineSDM: x.isLineSDM,
        deliveryDateReason: x.deliveryDateChangeReason,
        yourPrice: x.yourPrice,
        paymentTerms: x.paymentTerms,
        isBulkSetup: x.isBulkSetup,
        isBulkRowExceed: false,
        repackAgreement: x.repackAgreement,
        itemFlashMsgDesc: x.itemFlashMsgDesc,
        defaultChildItemId: x.defaultChildItemId,
        totalGallon: null,
        gallonConvFactor: x.gallonConvFactor,
        inventoryTag: x.inventoryTag,
        inventoryHover: x.inventoryHover,
        inventoryStopLightClass: x.inventoryStopLightClass,
        isBIO: x.isBIO,
        isDryItem: x.isDryItem,
        totalGlnPnd: x.isDryItem
          ? (x.poundConvFactor > 0 ? x.poundConvFactor : (x.gallonConvFactor > 0 ? x.gallonConvFactor : null))
          : x.gallonConvFactor,
        totalCalQtyGlnPnd: x.isDryItem
          ? (x.poundConvFactor > 0 ? x.poundConvFactor : (x.gallonConvFactor > 0 ? x.gallonConvFactor : null))
          : x.gallonConvFactor,
        measurementGlnPnd: x.isDryItem
          ? (x.poundConvFactor > 0 ? 'LB' : (x.gallonConvFactor > 0 ? 'GA' : null))
          : (x.gallonConvFactor > 0 ? 'GA' : null),
      };

      if (newRow.totalCalQtyGlnPnd == null || newRow.quantity == '' || newRow.quantity == 0) {
        newRow.totalGlnPnd = null;
      }
      else {
        newRow.totalGlnPnd = (+newRow.totalCalQtyGlnPnd * +(newRow.quantity));
      }
      orderList.splice(orderList.length, 0, newRow);
    });

    this.filteredDataCount = orderList.length;
    this.cppProductItemsDataSource.data = orderList;
    this.cppOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.isShowBulkContactDetails = this.cppOriginalProductItemsDataSource.some(x => x.bulkPackaged.toLowerCase() == 'BULK'.toLowerCase());
    this.isShowPackagedContactDetails = this.cppOriginalProductItemsDataSource.some(x => x.bulkPackaged.toLowerCase() == 'PACKAGED'.toLowerCase());
    this.validateDeliveryDateFilter();
    this.updateAdditionalRequest();
    if (this.cppProductItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }

    this.cppProductItemsDataSource.data.map(x => {
      x['openDatepicker'] = false;
      x['deliveryDate'] = this.datePipe.transform(x.deliveryDate, 'MM/dd/yyyy');
    });
  }

  // Enable/Disable Save Draft Button and Place Order Button
  enablePlaceOrderAndSaveOrderDraft() {
    if (this.readOnlyAccess) {
      this.isSaveOrderDraftEnable = false;
      this.isPlaceOrderEnable = false;
    }
    else {
      if (this.cppOriginalProductItemsDataSource && this.cppOriginalProductItemsDataSource.length > 0 && this.shipToAccount
        && (!this.isNotValid)) {
        this.isSaveOrderDraftEnable = true;
        this.isPlaceOrderEnable = true;
      }
      else {
        this.isSaveOrderDraftEnable = false;
        this.isPlaceOrderEnable = false;
      }
    }
  }

  // Show/Hide Product Detail section
  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // Load master data
  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    // get cpp Item Number List
    //this.subscription.push(this.cppService.getCppItemNumberList().subscribe((result: any[]) => {
    //  this.itemNoList = result;
    //}));

    // get Cpp Ship To Facility List
    //const getShipToFacility = this.cppService.getShipToFacilityList();
    //const getInstructionType = this.cppService.getCPPInstructionTypeList();
    this.subscription.push(this.cppService.getShipToFacilityList().subscribe((result: any[]) => {
      this.shipToFacilityList = result;
      this.loadAIData();
      //this.ddlInstructionTypeList = result[1];
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  loadAIData() {
    // Read item keys handed off from the AI CPP chatbot (stored as 'tempCartData').
    const aiCartData = this.localStorageService.get('tempCartData');
    this.loaderService.setLoaderStatus(true);
    if (aiCartData) {
      try {
        this.localStorageService.remove('tempCartData');
        const parsed = JSON.parse(aiCartData);
        this.aiCartItemKeys = Array.isArray(parsed?.itemNumbers) ? parsed.itemNumbers : (Array.isArray(parsed) ? parsed : []);
        const aiAccountNo = parsed?.accountNo ?? this.shipToAccount;
        const selectedShipTo = this.shipToFacilityList?.find(x => x.accountNumber == aiAccountNo);
        if (selectedShipTo) {
          this.cppService.deleteFromCart(aiAccountNo).subscribe((result: boolean) => {
            });
          this.shipToAccount = selectedShipTo.accountNumber;
          this.isVACartData = true;
          this.getShipTo(selectedShipTo);
        }
        if (this.aiCartItemKeys.length > 0) {
          this.checkAccountSDMEnabled();
          const filters: any = {
            itemNo: this.aiCartItemKeys.join(','),
            productName: null,
            activeIngredient: null,
            vendor: null,
            showFavoriteOnly: false,
            gtin: null,
            packageSize: null,
            productLine: null,
            productCategory: null,
            shipToOrDeliverToAccount: this.shipToAccount ?? aiAccountNo,
            shipToAccountNumber: this.shipToAccount ?? aiAccountNo,
            isCustomerPickup: false
          };
         
          this.subscription.push(this.cppService.getAllCppItemList(filters).subscribe((result: any) => {
            this.loaderService.setLoaderStatus(false);
            if (result && result.length > 0) {
              // this.productList = result;
              result.forEach(x => {
                x.quantity = x.setDefMinQty > 0 ? x.setDefMinQty : 0;
                x.orderQty = x.quantity;
                x.totalGallon = x.gallonConvFactor == null ? null : x.gallonConvFactor;
                x.isSelected = true;
              });
              this.formatNewAddedData(result);
              this.enablePlaceOrderAndSaveOrderDraft();              
            }
          }, error => {
            this.loaderService.setLoaderStatus(false);
            LolLoggerService.error(error);
          }));
        }
      } catch (error) {
        LolLoggerService.error(error);
        this.aiCartItemKeys = [];
      }    
      
    }
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // for adding product
  addProduct() {
    this.checkAccountSDMEnabled();
    this.setAddProductAnalytics();
    this.cppAddProductSliderModelService.shipToOrDeliverToAccount = this.deliverToAccount ? this.deliverToAccount : this.shipToAccount;
    this.cppAddProductSliderModelService.isCustomerPickup = this.isCustomerPickup;
    this.cppAddProductSliderModelService.shipToAccountNumber = this.shipToAccount;
    this.cppAddProductSliderModelService.soldToAccountNumber = this.soldToAccount;
    this.cppAddProductSliderModelService.activeSlider('AddCppProductSlider');
  }

  checkAccountSDMEnabled(resetReasonCodeRequire: boolean = true) {
    const accountNumber = this.deliverToAccount ? this.deliverToAccount : this.shipToAccount;
    this.subscription.push(this.cppService.getAccountSDMReasonCodeData(accountNumber).subscribe((result: any) => {
      this.isAccontSDM = result.accountSDM.isSDM;
      this.sdmSystemGeneratedDate = null;
      if (result.accountSDM.isSDM) {
        this.reasonList = result.sdmReasonCode;
      }
      this.selectedWeekdays = result.accountSDM.isSDM ? result.accountSDM.daysData : [];

      if (resetReasonCodeRequire && this.cppProductItemsDataSource && this.cppProductItemsDataSource.data && this.cppProductItemsDataSource.data.length > 0) {
        this.cppProductItemsDataSource.data.forEach(x => {
          this.reasonCodeRequire(x);
        });
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getDefaultDeliveryDate() {
    const accountNumber = this.deliverToAccount ? this.deliverToAccount : this.shipToAccount;
    const itemIds = this.cppProductItemsDataSource.data.map(y => y.itemId);
    if (itemIds.length > 0) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppService.getItemsSDM(itemIds.join(','), accountNumber, this.isCustomerPickup, this.shipToAccount).subscribe((result) => {
        this.itemsIdsWithSDM = result;
        this.cppProductItemsDataSource.data.forEach(x => {
          const item = this.itemsIdsWithSDM.filter(f => f.itemId == x.itemId)[0];
          if (x.bulkPackaged != 'BULK') {
            x.deliveryDate = this.datePipe.transform(item.desiredDelDate, 'MM/dd/yyyy');
            x.defaultDeliveryDate = item.defaultDelDate;
          }
          x.isLineSDM = item.isLineSDM;
          x.isReasonMandatory = false;
          x.deliveryDateReason = '';
          x.inventoryTag = item.inventoryTag;
          x.inventoryHover = item.inventoryHover;
          x.inventoryStopLightClass = item.inventoryStopLightClass;
        });

        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
    }
  }

  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.cppProductItemsDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.selectedCount = this.cppProductItemsDataSource.data.length;
    }
    else {
      this.showTabs = false;
      this.cppProductItemsDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.selectedCount = 0;
    }
    const checked = this.cppProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
      this.validateDeliveryDateFilter();
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.selectedCount = this.selectedCount + 1;
      const checked = this.cppProductItemsDataSource.data.filter(x => x.isSelected == false);
      if (checked && checked.length == 0) {
        this.allChecked = true;
      }
      else {
        this.allChecked = false;
      }
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      this.allChecked = false;
      const checked = this.cppProductItemsDataSource.data.filter(x => x.isSelected == true);
      {
        if (checked && checked.length == 0) {
          this.showTabs = false;
        }
      }
    }
    const checked = this.cppProductItemsDataSource.data.filter(x => x.isSelected == true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
      this.validateDeliveryDateFilter();
    }
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  // get total product count
  getTotalProductCount() {
    return this.cppProductItemsDataSource.data.length;
  }

  // set favorite
  selectForFavorite(element) {
    const isFavorite = element.isFavorite;
    if (element.isFavorite) {
      element.isFavorite = false;
    }
    else {
      element.isFavorite = true;
    }
    this.subscription.push(this.cppService.saveProductForfavorite(element.itemId, isFavorite).subscribe((result: any) => {
      element.isFavorite = result.item1;
      if (result.item2 == 1) {
        const dialog = this.matDialog.open(DialogComponent, {
          data: {
            title: 'Maximum limit for favorite items has been reached.', content: ''
          }
        });
        dialog.addPanelClass('max-limit-pop');
      }
    }));
  }

  getShipTo(event) {
    if (event) {
      this.isShowBulkContactDetails = false;
      this.isShowPackagedContactDetails = false;      

      this.getOrderDetails(event.parentNumber, 0);
      
      this.shipToAccountName = event.accountName;
      this.isAddProductEnable = true;   // Enable Add Product Button
      this.repackAgreement = event.repackAgreement;
    } else {
      this.deliverToList = null;
      this.deliverToAccount = null;
      this.soldToFacility = null;
      this.soldToAccount = null;
      this.isAddProductEnable = false;   // Disable Add Product Button
      this.disablecheckbox = true;
      this.isShowBulkContactDetails = false;
      this.isShowPackagedContactDetails = false;
      this.blkContactName = null;
      this.blkContactNumber = null;
    }
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.editToolKit = false;
    this.showTabs = false;
    this.cppProductItemsDataSource.data = [];
    this.cppOriginalProductItemsDataSource = [];
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails(parentAccountNumber, cppOrderId) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppService.getCppShipToOrderDetail((this.shipToAccount ? this.shipToAccount : 0), parentAccountNumber, cppOrderId).subscribe((result: any) => {
      if (result) {
        if (result.hasStopLightAccess) {
          this.lastUpdatedInv = result.inventoryUpdateDateTime;
          this.displayedColumns = ['checkbox', 'product', 'flashmsg', 'viewDetail', 'quantity', 'orderUOM', 'totalGallon', 'deliveryDate', 'deliveryDateReason', 'inventoryAvailability'];
        } else {
          this.displayedColumns = ['checkbox', 'product', 'flashmsg', 'viewDetail', 'quantity', 'orderUOM', 'totalGallon', 'deliveryDate', 'deliveryDateReason'];
        }
        if (parentAccountNumber > 0) {
          if (!this.isVACartData) {
            this.checkExistDraftOrder(result.cppEditOrderDetail, result.nonSubscribersEmailAddress);
          }
          // set delivery instruction
          this.setDeliveryInstructionsForNewOrder(result.deliveryInstructions);

          // set deliver to account
          this.deliverToList = result.deliverToLocations;
          
          // set sold to
          this.soldToFacility = [result.soldToAccount];
          this.soldToAccount = this.soldToFacility[0].accountNumber;
        }
        else {
          this.loadOrderDetails(result.cppEditOrderDetail)

          // set delivery instruction
          this.setDeliveryInstructionsForDraftOrder(result.deliveryInstructions, result.cppEditOrderDetail.packagedDeliveryInst);

          // set deliver to account
          this.deliverToList = result.deliverToLocations;
          this.deliverToAccount = result.cppEditOrderDetail.deliverToAccountId;
          this.deliverToAnotherLocation = result.cppEditOrderDetail.deliverToAccountId ? true : false;
          this.checkAccountSDMEnabled();

          // set sold to
          this.soldToFacility = [result.soldToAccount];
          this.soldToAccount = result.cppEditOrderDetail.soldToAccountId;

          this.enablePlaceOrderAndSaveOrderDraft();
          this.isSaveOrderDraftEnable = false;
        }
      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  checkExistDraftOrder(cppOrderDetails, nonSubEmail) {
    if (cppOrderDetails != null) {
      // Added Popup
      const title = 'Confirmation';
      const message = 'There is an existing Draft order for the selected account. Do you want to continue with that?';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '350px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });

      this.subscription.push(dialogRef.afterClosed().subscribe(yes => {
        if (yes == true) {// User selected Yes
          this.loadOrderDetails(cppOrderDetails);
          this.checkAccountSDMEnabled();
        }
        else {
          this.accountEmail = nonSubEmail;
        }
      }));
    }
    else {
      this.accountEmail = nonSubEmail;
    }
  }

  loadOrderDetails(shipToOrderDetails) {
    if (shipToOrderDetails) {
      this.webOrderNumber = shipToOrderDetails.webOrderNumber;
      this.shipToAccount = shipToOrderDetails.shipToAccountId;
      this.shipToAccountName = shipToOrderDetails.shipToAccountName;
      this.purchaseOrder = shipToOrderDetails.purchaseOrder;
      this.accountEmail = shipToOrderDetails.emailAddress;
      this.blkContactName = shipToOrderDetails.bulkContactName;
      this.blkContactNumber = shipToOrderDetails.userEnteredBulkContactPhoneNumber || shipToOrderDetails.bulkContactPhoneNumber;
      this.pkgContactName = shipToOrderDetails.packagedContactName;
      this.pkgContactNumber = shipToOrderDetails.userEnteredPackagedContactNumber || shipToOrderDetails.packagedContactNumber;
      if (shipToOrderDetails.packagedDeliveryInst) {
        this.cppDeliveryInstructionCode = shipToOrderDetails.packagedDeliveryInst.split(',');
      }
      else {
        this.cppDeliveryInstructionCode = new Array<string>();
      }
      this.specialInstructionText = shipToOrderDetails.specialInstruction == null ? '' : shipToOrderDetails.specialInstruction;
      this.instructionType = shipToOrderDetails.instructionType;
      this.isCustomerPickup = shipToOrderDetails.customerPickUp;
      this.formatEditOrderData(shipToOrderDetails.productList);
      this.repackAgreement = shipToOrderDetails.repackAgreement;
    }
  }

  setDeliveryInstructionsForDraftOrder(deliveryInstructions, packageDeliveryInstructions) {
    if (deliveryInstructions && deliveryInstructions.length > 0) {
      var bulkCppDeliveryInstruction = deliveryInstructions.filter(x => x.packagedType == 'BULK');
      if (bulkCppDeliveryInstruction && bulkCppDeliveryInstruction.length > 0) {
        bulkCppDeliveryInstruction.map(x => {
          x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
          x['contactName'] = x.firstName + ' ' + x.lastName;
        });
        this.cppDeliveryInstructionList = bulkCppDeliveryInstruction;
      }

      var packagedCppDeliveryInstruction = deliveryInstructions.filter(x => x.packagedType == 'PACKAGED');
      if (packagedCppDeliveryInstruction && packagedCppDeliveryInstruction.length > 0) {
        packagedCppDeliveryInstruction.map(x => {
          x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
          x['contactName'] = x.firstName + ' ' + x.lastName;
        });
        this.cppPackagedDeliveryInstructionList = packagedCppDeliveryInstruction;
      }

      if (this.blkContactName && this.blkContactNumber) {
        var selectedContact = this.blkContactName.replace(/ /g, '') + this.normalizeUsPhoneNumber(this.blkContactNumber);
        var primaryContact = bulkCppDeliveryInstruction.filter(x => x.contactNamePhoneNumber == selectedContact)[0];
        if (primaryContact) {
          this.cppBulkContactInfo = primaryContact.contactNamePhoneNumber;
        }
        else {
          primaryContact = { contactName: this.blkContactName, contactNamePhoneNumber: selectedContact, phoneNumber: this.normalizeUsPhoneNumber(this.blkContactNumber) };
          this.cppDeliveryInstructionList.push(primaryContact);
          this.cppBulkContactInfo = selectedContact;
        }
      }

      if (this.pkgContactName && this.pkgContactNumber) {
        var selectedContact = this.pkgContactName.replace(/ /g, '') + this.normalizeUsPhoneNumber(this.pkgContactNumber);
        var primaryContact = packagedCppDeliveryInstruction.filter(x => x.contactNamePhoneNumber == selectedContact)[0];
        if (primaryContact) {
          this.cppPackagedContactInfo = primaryContact.contactNamePhoneNumber;
          if (this.cppPackagedDeliveryInstructionList && this.cppPackagedDeliveryInstructionList.length > 0) {
            this.cppPackagedDeliveryInstructionList.forEach(x => {
              if (x.contactNamePhoneNumber == selectedContact) {
                x.deliveryInstructions = packageDeliveryInstructions;
              }
            });
          }
        }
        else {
          primaryContact = { contactName: this.pkgContactName, contactNamePhoneNumber: selectedContact, phoneNumber: this.normalizeUsPhoneNumber(this.pkgContactNumber) };
          this.cppPackagedDeliveryInstructionList.push(primaryContact);
          this.cppPackagedContactInfo = selectedContact;
        }
      }
    }
  }

  setDeliveryInstructionsForNewOrder(deliveryInstructions) {
    if (deliveryInstructions && deliveryInstructions.length > 0) {
      var bulkCppDeliveryInstruction = deliveryInstructions.filter(x => x.packagedType == 'BULK');
      if (bulkCppDeliveryInstruction && bulkCppDeliveryInstruction.length > 0) {
        bulkCppDeliveryInstruction.map(x => {
          x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
          x['contactName'] = x.firstName + ' ' + x.lastName;
        });
        this.cppDeliveryInstructionList = bulkCppDeliveryInstruction;

        var primaryContact = bulkCppDeliveryInstruction.filter(x => x.contactType.toLowerCase() == 'primary')[0];
        if (primaryContact) {
          this.cppBulkContactInfo = primaryContact.contactNamePhoneNumber;
          this.blkContactName = primaryContact.contactName;
          this.blkContactNumber = primaryContact.phoneNumber;
        }
        else {
          this.cppBulkContactInfo = bulkCppDeliveryInstruction[0].contactNamePhoneNumber;
          this.blkContactName = bulkCppDeliveryInstruction[0].contactName;
          this.blkContactNumber = bulkCppDeliveryInstruction[0].phoneNumber;
        }
      }
      else {
        this.cppBulkContactInfo = null;
        this.blkContactName = null;
        this.blkContactNumber = null;
        this.cppDeliveryInstructionList = null;
      }

      var packagedCppDeliveryInstruction = deliveryInstructions.filter(x => x.packagedType == 'PACKAGED');
      if (packagedCppDeliveryInstruction && packagedCppDeliveryInstruction.length > 0) {
        packagedCppDeliveryInstruction.map(x => {
          x['contactNamePhoneNumber'] = x.firstName + x.lastName + x.phoneNumber;
          x['contactName'] = x.firstName + ' ' + x.lastName;
        });
        this.cppPackagedDeliveryInstructionList = packagedCppDeliveryInstruction;

        var primaryContact = packagedCppDeliveryInstruction.filter(x => x.contactType.toLowerCase() == 'primary')[0];
        if (primaryContact) {
          this.cppPackagedContactInfo = primaryContact.contactNamePhoneNumber;
          this.pkgContactName = primaryContact.contactName;
          this.pkgContactNumber = primaryContact.phoneNumber;
          if (primaryContact.deliveryInstructions) {
            this.cppDeliveryInstructionCode = primaryContact.deliveryInstructions.split(',');
          }
          else {
            this.cppDeliveryInstructionCode = new Array<string>();
          }
        }
        else {
          this.cppPackagedContactInfo = packagedCppDeliveryInstruction[0].contactNamePhoneNumber;
          this.pkgContactName = packagedCppDeliveryInstruction[0].contactName;
          this.pkgContactNumber = packagedCppDeliveryInstruction[0].phoneNumber;
        }
      }
      else {
        this.cppPackagedContactInfo = null;
        this.pkgContactName = null;
        this.pkgContactNumber = null;
        this.cppPackagedDeliveryInstructionList = null;
      }
    }
    else {
      this.cppBulkContactInfo = null;
      this.blkContactName = null;
      this.blkContactNumber = null;
      this.cppDeliveryInstructionList = null;
      this.cppPackagedContactInfo = null;
      this.pkgContactName = null;
      this.pkgContactNumber = null;
      this.cppPackagedDeliveryInstructionList = null;
    }
  }
  UpdateDeliverToSelection(isDeliverToOptionChecked) {
    if (!isDeliverToOptionChecked) {
      this.deliverToAccount = null;
      this.checkAccountSDMEnabled(false);
      this.getDefaultDeliveryDate();
    }
  }

  getDeliverTo($event) {
    this.checkAccountSDMEnabled(false);
    this.getDefaultDeliveryDate();

    if ($event && this.isEditMode) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppDeliverToValue: true });
    }
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  getBulkContactPhone(event) {
    if (event && event.contactName && event.phoneNumber) {
      this.blkContactNumber = event.phoneNumber;
      this.blkContactName = event.contactName;
      this.lastBulkContactSearched = null;
    }
    else if (event) {
      this.blkContactName = event.contactName;
      this.blkContactNumber = null;
    }
    else {
      this.blkContactNumber = null;
      this.blkContactName = null;
      this.lastBulkContactSearched = null;
    }
  }

  getPackagedContactPhone(event) {
    if (event && event.contactName && event.phoneNumber) {
      this.pkgContactNumber = event.phoneNumber;
      this.pkgContactName = event.contactName;
      this.lastPackagedContactSearched = null;
      if (event.deliveryInstructions) {
        this.cppDeliveryInstructionCode = event.deliveryInstructions.split(',');
      }
      else {
        this.cppDeliveryInstructionCode = new Array<string>();
      }
    }
    else if (event) {
      this.pkgContactName = event.contactName;
      this.pkgContactNumber = null;
      this.cppDeliveryInstructionCode = new Array<string>();
    }
    else {
      this.pkgContactNumber = null;
      this.pkgContactName = null;
      this.lastPackagedContactSearched = null;
      this.cppDeliveryInstructionCode = new Array<string>();
    }
  }

  // Search the bulk contact name
  bulkContactNameSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.firstName.toLocaleLowerCase().indexOf(term) > -1
      || item.lastName.toLocaleLowerCase().indexOf(term) > -1;
  }

  //Search the bulk contact name
  packagedContactNameSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.firstName.toLocaleLowerCase().indexOf(term) > -1
      || item.lastName.toLocaleLowerCase().indexOf(term) > -1;
  }

  createNewContact() {
    if (this.lastBulkContactSearched) {
      let isContactNameExists = null;
      if (this.cppDeliveryInstructionList && this.cppDeliveryInstructionList.length > 0) {
        isContactNameExists = this.cppDeliveryInstructionList.filter(x => x.contactNamePhoneNumber == this.lastBulkContactSearched)[0];
      }

      if (!isContactNameExists) {
        const primaryContact = { contactName: this.lastBulkContactSearched, contactNamePhoneNumber: this.lastBulkContactSearched, phoneNumber: '' };
        if (this.cppDeliveryInstructionList && this.cppDeliveryInstructionList.length > 0) {
          this.cppDeliveryInstructionList = [...this.cppDeliveryInstructionList, primaryContact];
        }
        else {
          this.cppDeliveryInstructionList = [primaryContact];
        }
        this.cppBulkContactInfo = this.lastBulkContactSearched;
        this.blkContactName = this.lastBulkContactSearched;
        this.blkContactNumber = null;
      }
    }
  }

  createNewPackagedContact() {
    if (this.lastPackagedContactSearched) {
      var isContactNameExists = null;
      if (this.cppPackagedDeliveryInstructionList && this.cppPackagedDeliveryInstructionList.length > 0) {
        isContactNameExists = this.cppPackagedDeliveryInstructionList.filter(x => x.contactNamePhoneNumber == this.lastPackagedContactSearched)[0];
      }

      if (!isContactNameExists) {
        var primaryContact = { contactName: this.lastPackagedContactSearched, contactNamePhoneNumber: this.lastPackagedContactSearched, phoneNumber: '' };
        if (this.cppPackagedDeliveryInstructionList && this.cppPackagedDeliveryInstructionList.length > 0) {
          this.cppPackagedDeliveryInstructionList = [...this.cppPackagedDeliveryInstructionList, primaryContact];
        }
        else {
          this.cppPackagedDeliveryInstructionList = [primaryContact];
        }
        this.cppPackagedContactInfo = this.lastPackagedContactSearched;
        this.pkgContactName = this.lastPackagedContactSearched;
        this.pkgContactNumber = null;
        this.cppDeliveryInstructionCode = new Array<string>();
      }
    }
  }

  customerPickupChange() {
    this.checkAccountSDMEnabled(false);
    this.getDefaultDeliveryDate();
  }

  hasHeaderInfoChanged(fieldName) {
    if (fieldName && this.shipToAccount && this.isEditMode) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      switch (fieldName) {
        case 'PO':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
          break;
        case 'Special Instructions':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppSplInsValue: true });
          break;
        case 'Instruction Type':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppInsTypeValue: true });
          break;
        case 'Customer Pickup':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppCustPickupValue: true });
          break;
        case 'Email Address':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppEmailAddressValue: true });
          break;
        case 'Bulk Name':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppBulkNameValue: true });
          break;
        case 'Bulk Number':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppBulkNumberValue: true });
          break;
      }
      this.enablePlaceOrderAndSaveOrderDraft();
    }
  }

  validateDeliveryDateFilter() {
    const currentDate = new Date();
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.config.maxDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 7, day: currentDate.getDate() };
    // this.datemodel = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() + 4 };//this.configDate.getToday();

    const sdmlines = this.cppProductItemsDataSource.data.filter(x => x.isSelected == true /* && x.islinesdm == true*/);
    const selecteLineCount = sdmlines.length;
    if (sdmlines && selecteLineCount > 0) {
      const firstdate = sdmlines[0].deliveryDate;
      if (firstdate !== null && firstdate !== undefined && firstdate !== '') {
        const datecount = sdmlines.filter(x => new Date(x.deliveryDate).getTime() == new Date(firstdate).getTime()).length;
        if (datecount == selecteLineCount) {
          const fDate = new Date(firstdate);
          this.datemodel = { year: fDate.getFullYear(), month: fDate.getMonth() + 1, day: fDate.getDate() };
        }
        else {
          this.datemodel = this.configDate.getToday();
        }
      }
      else {
        this.datemodel = this.configDate.getToday();
      }
    }
    else {
      this.datemodel = this.configDate.getToday();
    }

    this.tabNode = '';
  }

  SetAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        if (value == true) {
          this.deleteSelectedAccount();
          const refreshData = [];
          this.cppProductItemsDataSource.data.forEach(item => {
            if (item.isSelected) {
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
              refreshData.push(item.itemId);
              this.selectedCount = this.selectedCount - 1;
              item.isSelected = false;
            }
          });

          const filterDataAfterDeletion = this.cppProductItemsDataSource.data.filter(x => refreshData.indexOf(x.itemId) == -1);
          this.isShowBulkContactDetails = filterDataAfterDeletion.some(x => x.bulkPackaged.toLowerCase() == 'BULK'.toLowerCase());
          this.isShowPackagedContactDetails = filterDataAfterDeletion.some(x => x.bulkPackaged.toLowerCase() == 'PACKAGED'.toLowerCase());
          if (filterDataAfterDeletion.length < 1) {
            this.disablecheckbox = true;
          }
          this.cppProductItemsDataSource = new MatTableDataSource(filterDataAfterDeletion);
          this.cppOriginalProductItemsDataSource = JSON.parse(JSON.stringify(this.cppProductItemsDataSource.data));
          this.enablePlaceOrderAndSaveOrderDraft();
        }
        this.setCount();
        this.tabNode = '';
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.editToolKit = false;
        this.showTabs = false;
        this.showErrorBlock = false;
        break;

      case 'deliverydate':
        this.cppProductItemsDataSource.data.forEach(item => {
          if (item.isSelected) {
            item.deliveryDate = this.datePipe.transform(new Date(value.year, value.month - 1, value.day), 'MM/dd/yyyy');
            this.validateDate(item);
            this.selectedCount = this.selectedCount - 1;
            item.isSelected = false;
          }
        });

        this.cppOriginalProductItemsDataSource = JSON.parse(JSON.stringify(this.cppProductItemsDataSource.data));
        this.setCount();
        this.enableAllCheckBoxes(false);
        this.selectedCount = 0;
        this.validateDeliveryDateFilter();
        this.showTabs = false;
        this.editToolKit = false;
        break;
      default:
        break;
    }
  }

  // Date validation
  validateDate(productItem: any) {
    const oldProductLineValue = JSON.parse(JSON.stringify(this.cppOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPDateValue: oldProductLineValue.deliveryDate, newCPPDateValue: productItem.deliveryDate });

    if (productItem.isLineSDM) {
      this.cppProductItemsDataSource.data.forEach(item => {
        // update reason code if delivery dates are same
        if (item.rowId != productItem.rowId && item.isLineSDM
          && new Date(item.deliveryDate).getTime() == new Date(productItem.deliveryDate).getTime()) {
          productItem.deliveryDateReason = item.deliveryDateReason;
          return;
        }
      });
      this.reasonCodeRequire(productItem);
    }

    if ((productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0)
    ) {
      this.validateLineItem(productItem);
    }

    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  reasonCodeRequire(productItem: any) {
    if (productItem.isLineSDM) {
      const dDate = new Date(productItem.deliveryDate);
      const ngDate: NgbDate = new NgbDate(dDate.getFullYear(), dDate.getMonth() + 1, dDate.getDate());

      if (this.selectedWeekdays.some(x => x == this.calendar.getWeekday(ngDate))
        && new Date(productItem.defaultDeliveryDate).getTime() <= new Date(productItem.deliveryDate).getTime()) {
        productItem.isReasonMandatory = false;
        productItem.deliveryDateReason = '';
      }
      else {
        productItem.isReasonMandatory = true;
      }
    }
  }

  showRepackPopup(items) {
    // Added Popup
    const title = 'Confirmation';
    let message = 'A Repack Agreement(s) is expired or missing for ';
    let itemdata = '';
    for (let i = 0; i < items.length; i++) {
      if (items.length == 1 && i == 0) {
        itemdata = itemdata + items[i] + '\n';
        message = message + '\n' + itemdata;
      }
      else if (items.length == 2) {
        itemdata = itemdata + items[i] + '\n';
        if (i == 1) { message = message + '\n' + itemdata; }
      }
      else if (items.length > 2) {
        itemdata = itemdata + '\n' + items[i] + '\n';
      }
    }
    if (items.length > 2) {
      message = message + 'more than 2 items:' + '\n' + itemdata;
    }
    message = message + '\n' + ' This item will not ship until a repack agreement has been signed. Please reach out to winfieldcustomerservice@landolakes.com or 855-494-6343 to get an agreement sent.';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '550px',
      height: '250px',
      data: { title: title, message: message, labelYes: 'Continue', labelNo: 'No', dialogType: 'repackItem' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(yes => {
      if (yes == true) {// User selected Yes
        this.placeOrder();
      }
    }));
  }

  showDuplicatePOPopup(message: string) {
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      height: '300px',
      data: {
        title: 'Confirmation',
        message: message,
        labelYes: 'Yes',
        labelNo: 'No, go back to Order',
        dialogType: 'confirm'
      }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(yes => {
      if (yes == true) {
        this.bypassDuplicatePOCheck = true;
        this.placeOrder();
      } else {
        this.bypassDuplicatePOCheck = false;
      }
    }));
  }

  validateplaceOrder() {
    if (this.cppProductItemsDataSource.data.length > 0) {
      const items = new Array();
      let repackItems = 0;
      for (let i = 0; i < this.cppProductItemsDataSource.data.length; i++) {
        if ((this.cppProductItemsDataSource.data[i].isRepackItem == 'Y' && this.cppProductItemsDataSource.data[i].repackAgreement == 'N') || (this.cppProductItemsDataSource.data[i].isRepackItem == 'Y' && this.cppProductItemsDataSource.data[i].repackAgreement == null) || (this.cppProductItemsDataSource.data[i].isRepackItem == 'Y' && this.cppProductItemsDataSource.data[i].repackAgreement == '')) {
          if (this.cppProductItemsDataSource.data.length == 1) {
            items.push(this.cppProductItemsDataSource.data[i].itemDescription + ', ' + this.cppProductItemsDataSource.data[i].itemNumber + ';');
          } else {
            items.push(this.cppProductItemsDataSource.data[i].itemDescription + ', ' + this.cppProductItemsDataSource.data[i].itemNumber + ';');
          }
          repackItems++;
        }
      }
      if (repackItems > 0) {
        this.showRepackPopup(items);
      }
      else {
        this.placeOrder();
      }
    }
  }

  placeOrder() {
    if (this.isContactPhoneInvalid()) {
      this.toastrService.error('Please enter a valid 10 digit phone number.');
      return;
    }
    if (!this.validateEmail()) {
      $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
      this.isPlaceOrderEnable = false;
      const saveObj: any = {};
      saveObj.cPPOrderId = this.orderId;
      saveObj.companyCode = this.headerCompany;
      saveObj.shipToAccountId = this.shipToAccount;
      saveObj.deliverToId = this.deliverToAccount;
      saveObj.soldToId = this.soldToAccount;
      saveObj.purchaseOrderNumber = this.purchaseOrder;
      saveObj.bypassDuplicatePOCheck = this.bypassDuplicatePOCheck;
      saveObj.bulkContactName = this.isShowBulkContactDetails ? this.blkContactName : null;
      saveObj.bulkContactPhoneNumber = this.isShowBulkContactDetails ? this.normalizeUsPhoneNumber(this.blkContactNumber) : null;
      saveObj.packagedContactName = this.isShowPackagedContactDetails ? this.pkgContactName : null;
      saveObj.packagedContactNumber = this.isShowPackagedContactDetails ? this.normalizeUsPhoneNumber(this.pkgContactNumber) : null;
      saveObj.userEnteredBulkContactPhoneNumber = this.isShowBulkContactDetails ? this.blkContactNumber : null;
      saveObj.userEnteredPackagedContactNumber = this.isShowPackagedContactDetails ? this.pkgContactNumber : null;
      saveObj.packagedDeliveryInst = this.isShowPackagedContactDetails && this.cppDeliveryInstructionCode && this.cppDeliveryInstructionCode.length > 0 ? this.cppDeliveryInstructionCode.join(',') : null;
      if ((this.specialInstructionText && (this.specialInstructionText.trim() != ""))) {
        saveObj.headerText = this.specialInstructionText.trim();
        saveObj.instructionType = 41;// this.instructionType;
      }

      saveObj.emailAddress = this.accountEmail;
      saveObj.customerPickUp = this.isCustomerPickup;
      saveObj.cppProductList = this.cppProductItemsDataSource.data;

      saveObj.cppProductList.forEach(x => {
        x.deliverydate = (new Date(x.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
        x.modifiedOrderedQuantity = x.orderConvFactor * x.quantity,
          x.pricingQuantity = x.pricingUnitConvFactor * x.quantity,
          x.rowId = x.rowId;
      });
      let isValidated = true;
      if (this.validateOrder(false)) {
        this.setPlaceOrderAnalytics();
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.cppService.placeOrder(saveObj).subscribe((result: any) => {
          if (result) {
            if (result.isDuplicateCustomerPO) {
              this.loaderService.setLoaderStatus(false);
              this.isPlaceOrderEnable = true;
              this.showDuplicatePOPopup(result.duplicateCustomerPOMessage);
              return;
            }
            if (result.errors.length > 0) {
              result.errors.forEach(x => {
                this.toastrService.error(x);
                this.setErrorAnalytics(x);
                isValidated = false;
                return false;
              });
            }

            if (result.cppProductList.length > 0) {
              const cppProductList = result.cppProductList;
              this.cppProductItemsDataSource.data.forEach(x => {
                const item = cppProductList.filter(z => z.itemId == x.itemId && z.rowId == x.rowId);

                if (item[0].isInValidItem) {
                  isValidated = false;
                  x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'validItem');
                  x.lineErrors.errors.push({ id: 'validItem', error: 'This product is not available for ordering' });
                }
                else {
                  x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'validItem');
                  x.lineErrors.errors = item[0].lineErrors.errors;
                  this.errorMsgs = this.errorMsgs.filter(y => y.rowId != item.rowId);
                }

                if (x.lineErrors.errors.length > 0) {
                  isValidated = false;
                  this.errorMsgs.push(x.lineErrors);
                  this.getCommonErrors(this.errorMsgs);
                  x.lineErrors.errors.forEach(er => {
                    this.setErrorAnalytics(er.error);
                  });
                }
              });
            }

            if (isValidated) {
              this.toastrService.success('Order #' + result.webOrderNumber + ' placed successfully.');
              this.cppService.webOrderNumberAndSplitId = result.webOrderNumber + '~' + 0 + '~ ' + '~CPPLanding';// Done '~ ' so that we could show non errored data
              this.router.navigate(['/cpp/cpp-order-summary']);
              this.cppService.setRedirectionFrom('placeOrder');
              this.cppService.shouldShowSurveyMessage = this.shouldShowSurveyMessage;
              this.cppService.evolveSurveyUrl = this.evolveSurveyUrl;
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            }
            this.bypassDuplicatePOCheck = false;
            this.loaderService.setLoaderStatus(false);
          }
        }, (error) => {
          this.isPlaceOrderEnable = true;
          this.bypassDuplicatePOCheck = false;
          this.loaderService.setLoaderStatus(false);
          let errorMsg = 'Order not saved in the system.'
          this.toastrService.error(errorMsg);
          this.setErrorAnalytics(errorMsg);
          LolLoggerService.error(error);
        }));
      }
    }
    else {
      let errorMsg = 'Enter a valid email.'
      this.toastrService.warning(errorMsg);
      this.setErrorAnalytics(errorMsg);
    }
  }

  saveDraft() {
    if (this.isContactPhoneInvalid()) {
      this.toastrService.error('Please enter a valid 10 digit phone number.');
      return;
    }
    if (!this.validateEmail()) {
      $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
      const saveObj: any = {};
      saveObj.isUpdateRequest = (this.isEditMode) ? true : false;
      saveObj.cPPOrderId = this.orderId;
      saveObj.companyCode = this.headerCompany;
      saveObj.shipToAccountId = this.shipToAccount;
      saveObj.deliverToId = this.deliverToAccount;
      saveObj.soldToId = this.soldToAccount;
      saveObj.purchaseOrderNumber = this.purchaseOrder;
      if ((this.specialInstructionText && (this.specialInstructionText != ''))) {
        saveObj.instructionType = 41;
      }

      saveObj.headerText = this.specialInstructionText;
      saveObj.emailAddress = this.accountEmail;
      saveObj.bulkContactName = this.isShowBulkContactDetails ? this.blkContactName : null;
      saveObj.bulkContactPhoneNumber = this.isShowBulkContactDetails ? this.normalizeUsPhoneNumber(this.blkContactNumber) : null;
      saveObj.packagedContactName = this.isShowPackagedContactDetails ? this.pkgContactName : null;
      saveObj.packagedContactNumber = this.isShowPackagedContactDetails ? this.normalizeUsPhoneNumber(this.pkgContactNumber) : null;
      saveObj.userEnteredBulkContactPhoneNumber = this.isShowBulkContactDetails ? this.blkContactNumber : null;
      saveObj.userEnteredPackagedContactNumber = this.isShowPackagedContactDetails ? this.pkgContactNumber : null;
      saveObj.packagedDeliveryInst = this.cppDeliveryInstructionCode && this.cppDeliveryInstructionCode.length > 0 ? this.cppDeliveryInstructionCode.join(',') : null;
      saveObj.customerPickUp = this.isCustomerPickup;
      saveObj.cppProductList = JSON.parse(JSON.stringify(this.cppProductItemsDataSource.data));

      saveObj.cppProductList.forEach(x => {
        if (x.bulkPackaged == 'BULK' && x.deliveryDate == null) {
          x.deliverydate = null;
        } else {
          x.deliverydate = (new Date(x.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
        }

        x.modifiedOrderedQuantity = x.orderConvFactor * x.quantity;
        x.pricingQuantity = x.pricingUnitConvFactor * x.quantity;
      });
      if (this.validateOrder(true)) {
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.cppService.saveOrder(saveObj).subscribe((result: any) => {
          if (result) {
            if (result.errors.length > 0) {
              this.loaderService.setLoaderStatus(false);
              result.errors.forEach(x => {
                this.toastrService.error(x);
                this.setErrorAnalytics(x);
                return false;
              });
            }
            else {
              const successMsg = (this.isEditMode) ? 'Order #' + result.webOrderNumber + ' updated successfully.' : 'CPP Order #' + result.webOrderNumber + ' saved successfully.';
              this.toastrService.success(successMsg);
              this.router.navigate(['/cpp/landing-data']);
              this.commonService.currentTabIndex.next(1);
              this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
              this.loaderService.setLoaderStatus(false);
            }
          }
        }, (error) => {
          this.loaderService.setLoaderStatus(false);
          let errorMsg = 'Order not saved in the system.';
          this.toastrService.error(errorMsg);
          this.setErrorAnalytics(errorMsg);
          LolLoggerService.error(error);
        }));
      }
    }
    else {
      let errorMsg = 'Enter a valid email.';
      this.toastrService.warning(errorMsg);
      this.setErrorAnalytics(errorMsg);
    }
  }

  // validation on Save Draft
  validateOrder(isDraftCall) {
    isDraftCall = isDraftCall ? isDraftCall : false;
    let isValidated = true;
    if (this.cppProductItemsDataSource.data && this.cppProductItemsDataSource.data.length > 0) {
      isValidated = true;
      this.cppProductItemsDataSource.data.forEach(x => {
        if (!isDraftCall) {
          x = this.validateLineItem(x);
          if (x.lineErrors.errors.length > 0) {
            this.errorMsgs.push(x.lineErrors);
            this.getCommonErrors(this.errorMsgs);
            isValidated = false;
          }
        }
      });
    }
    return isValidated;
  }

  // Line item validation
  validateLineItem(item: any) {
    if (item.quantity <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'Quantity should be greater than zero' });
      this.setErrorAnalytics('Quantity should be greater than zero');
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }
    const currentDate = (new Date()).toLocaleDateString('en-US').replace(/\u200E/g, '');
    if (item.deliveryDate == null || item.deliveryDate == '') {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      item.lineErrors.errors.push({ id: 'deliveryDate', error: 'Requested Arrival Date is required.' });
      this.setErrorAnalytics('Requested Arrival Date is required.');
    }
    else if (Date.parse((new Date(item.deliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '')) < Date.parse(currentDate)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      item.lineErrors.errors.push({ id: 'deliveryDate', error: 'Requested Arrival Date should be greater than equal to current date.' });
      this.setErrorAnalytics('Requested Arrival Date should be greater than equal to current date.');
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDate');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    if (item.isLineSDM && item.isReasonMandatory && !item.deliveryDateReason) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDateReason');
      item.lineErrors.errors.push({ id: 'deliveryDateReason', error: 'Please enter Reason Code.' });
      this.setErrorAnalytics('Please enter Reason Code.');
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deliveryDateReason');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    // Adding Error for Addition Request Delivery date for US#104604
    if (item.bulkPackaged == 'BULK') {
      this.validateRequestDate(item.itemNumber);
    }

    // remove service side errors
    item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantityRestriction');
    this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conversion');
    this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'shippingQuantity');
    this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);

    return item;
  }

  validateRequestDate(itemNumber) {
    this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === itemNumber && x1.bulkPackaged === 'BULK').forEach(data => {
      const countRow = this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === itemNumber && x1.bulkPackaged == 'BULK').length;
      const countRowWithDate = this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === itemNumber
        && x1.bulkPackaged == 'BULK' && x1.deliveryDate != null).length;
      if (countRow == countRowWithDate) {
        let isSameDate = false;
        const filterData = this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === itemNumber
          && x1.bulkPackaged == 'BULK');

        let countDate = 0;
        filterData.forEach(x => {
          if (new Date(x.deliveryDate).getTime() != new Date(data.deliveryDate).getTime()) {
            // isSameDate = false;
          } else {
            countDate = countDate + 1;
          }
        });

        if (countDate > 1) {
          isSameDate = true;
        }

        if (countRow != 1 && isSameDate) {
          this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === itemNumber && x1.deliveryDate === data.deliveryDate).
            forEach(x => {
              x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'sameDate');
              x.lineErrors.errors.push({ id: 'sameDate', error: 'The Requested Arrival Dates need to be different on each line for the same item number.' });
              this.setErrorAnalytics('The Requested Arrival Dates need to be different on each line for the same item number.');
            });
        }
        else {
          this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === itemNumber && x1.rowId == data.rowId).forEach(x => {
            x.lineErrors.errors = x.lineErrors.errors.filter(y => y.id != 'sameDate');
            this.errorMsgs = this.errorMsgs.filter(x => x.rowId != x.rowId);
          });
        }
      } else {
        this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === itemNumber).forEach(x1 => {
          x1.lineErrors.errors = x1.lineErrors.errors.filter(y => y.id != 'sameDate');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != x1.rowId);
        });
      }
    });
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#cppOrderView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#cppOrderView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#cppOrderView').scrollTop = 0;
      $('#cppOrderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.cppOriginalProductItemsDataSource.length > 0 && this.cppProductItemsDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        this.revertSingleIndex(element);
      }
      else {
        // revert lines having error only
        this.cppProductItemsDataSource.data.forEach(x => {
          if (x.lineErrors && x.lineErrors.errors && x.lineErrors.errors.length > 0) {
            this.revertSingleIndex(x);
          }
        });

        this.errorMsgs = new Array();
      }
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  revertSingleIndex(element: any) {
    if (element && element != null) {
      // get old data
      const oldLineValue = this.cppOriginalProductItemsDataSource.filter(x => x.rowId == element.rowId)[0];

      // get current object index
      const currentLineIndex = this.cppProductItemsDataSource.data.findIndex(x => x.rowId == element.rowId);

      // replace current with old object if exist
      if (currentLineIndex != -1) {
        this.cppProductItemsDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
        this.cppProductItemsDataSource.data = this.cppProductItemsDataSource.data;

        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

        // to hide one error after revert changes
        this.showHideLineError(oldLineValue.rowId);
        this.getCommonErrors(this.errorMsgs);
      }
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Dealer unit change and validation
  cppUnitChange(action: string, productItem: any) {
    productItem.quantity = this.isNumber(productItem.quantity) == true ? productItem.quantity : 0;

    if (action == 'decrease') {
      const decValue = +productItem.quantity - 1;
      if (decValue > 0) {
        productItem.quantity = decValue;
      }
      else {
        productItem.quantity = 1;
      }
    }
    else {
      productItem.quantity = +productItem.quantity + 1;
    }

    if (productItem.allowDecimal) {
      productItem.quantity = (+productItem.quantity).toFixed(this.commonService.countDecimals(+productItem.quantity));
    }
    this.computeGallon(productItem);
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.cppOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPQtyValue: oldProductLineValue.quantity, newCPPQtyValue: productItem.quantity });
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem);
    }
    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    productItem.quantity = this.isNumber(productItem.quantity) == true ? productItem.quantity : 0;
    if (/^0/.test(productItem.quantity) && productItem.quantity != '0') {
      productItem.quantity = productItem.quantity.replace(/^0/, '');
    }
    this.computeGallon(productItem);
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.cppOriginalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.setCount();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCPPQtyValue: oldProductLineValue.quantity, newCPPQtyValue: productItem.quantity });
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem);
    }

    this.isAddProductEnable = true;   // Enable Add Product Button
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  computeGallon(productItem: any) {
    if (productItem.totalCalQtyGlnPnd == null || productItem.quantity == '' || productItem.quantity == 0) {
      productItem.totalGlnPnd = null;
    }
    else {
      productItem.totalGlnPnd = (+productItem.totalCalQtyGlnPnd * +(productItem.quantity));
    }
  }

  setCount() {
    this.filteredDataCount = 0;
    this.qtyCount = 0;
    this.totalPrice = 0;
    this.filteredDataCount = this.cppProductItemsDataSource.data.length;
    this.cppProductItemsDataSource.data.forEach(x => {
      this.qtyCount = this.qtyCount + +(x.quantity);
      this.totalPrice = this.totalPrice + (x.quantity * x.price);
    });
  }

  navigateToLandingPage() {
    this.router.navigate(['/cpp/landing-data']);
    this.commonService.currentTabIndex.next(1);
  }

  setAddProductAnalytics() {
    var eventData = {
      'event': 'Add Product',
      'shipToAccountID': this.shipToAccount,
      'soldToAccountID': this.soldToAccount,
    };

    this.commonService.setDataLayerAnalytics(eventData);
  }

  setPlaceOrderAnalytics() {
    var eventData = {
      'event': 'Place Order'
    };

    this.commonService.setDataLayerAnalytics(eventData);
  }

  setErrorAnalytics(errorMsg) {
    var eventData = {
      'event': 'form_error',
      'formName': 'Evolve – Crop Protection Order',
      'errorMessage': errorMsg
    };

    this.commonService.setDataLayerAnalytics(eventData);
  }

  GetDisclaimerMessage() {
    this.subscription.push(this.cppService.GetDisclaimerMessage().subscribe((result: any) => {
      if (result) {
        this.dynamicDisclaimerMessage = result.message;
      }
    }, error => LolLoggerService.error(error)));
  }

  // On page destroy
  ngOnDestroy() {
    this.cppService.setCppOrderId(0);
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    if (!this.isNotValid) {
      this.enablePlaceOrderAndSaveOrderDraft();
    }
    this.matcher = new InputErrorStateMatcher(this.isNotValid);
    return this.isNotValid;
  }

  // Strips formatting and a leading 1/+1 country code to the 10-digit number (applied on save, not on display)
  private normalizeUsPhoneNumber(rawPhone: string): string {
    if (!rawPhone) { return rawPhone; }
    let digits = rawPhone.toString().replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') {
      digits = digits.substring(1);
    }
    return digits;
  }

  keyPressPhone(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[0-9+()\-.\s]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onPhonePaste(event: ClipboardEvent, phone: AbstractControl) {
    event.preventDefault();
    const pasted = event.clipboardData ? event.clipboardData.getData('text') : '';
    // Remove only leading spaces; inner and trailing characters are left untouched
    const cleaned = pasted.replace(/^\s+/, '');
    phone.setValue(cleaned);
    phone.markAsTouched();
  }

  // Blocks save when a shown contact phone has a value that isn't a valid US phone number
  private isContactPhoneInvalid(): boolean {
    if (this.isShowBulkContactDetails && this.blkContactNumber && !this.phonePattern.test(this.blkContactNumber)) { return true; }
    if (this.isShowPackagedContactDetails && this.pkgContactNumber && !this.phonePattern.test(this.pkgContactNumber)) { return true; }
    return false;
  }

  validateCustPO() {
    this.isCustPONotValid = false;
    if (this.purchaseOrder && !this.alphaNumericPattern.test(this.purchaseOrder)) {
      this.isCustPONotValid = true;
    };
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  keyPressAlphaNumeric(event, isValidateCustPO) {
    const inp = String.fromCharCode(event.keyCode);
    if (this.alphaNumericPattern.test(inp)) {
      if (isValidateCustPO == 1) { this.validateCustPO(); }
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaNumericWithSpace(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (this.alphaNumericPatternWithSpace.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  // highlighting weekdays
  getIsHoliday(date: NgbDate) {
    const todayDate = new Date();
    if (this.isAnyLineSMDSelected()
      && new Date(date.year, date.month - 1, date.day) >= this.sdmSystemGeneratedDate
      && new Date(date.year, date.month - 1, date.day) >= todayDate) {
      return this.selectedWeekdays.includes(this.calendar.getWeekday(date));
    } else {
      return false;
    }
  }

  // highlighting weekdays
  getIsRequestHoliday(date: NgbDate, element: any) {
    const todayDate = new Date();
    if (!element.deliveryDate
      && element.isLineSDM
      && new Date(date.year, date.month - 1, date.day) >= this.sdmSystemGeneratedDate
      && new Date(date.year, date.month - 1, date.day) >= todayDate) {
      return this.selectedWeekdays.includes(this.calendar.getWeekday(date));
    }
    else if (element.deliveryDate
      && element.isLineSDM
      && new Date(date.year, date.month - 1, date.day) >= new Date(element.deliveryDate)) {
      return this.selectedWeekdays.includes(this.calendar.getWeekday(date));
    } else {
      return false;
    }
  }

  getRequestDateType(date: NgbDate, element: any) {
    var requestDateType = '';
    if (this.selectedWeekdays && this.selectedWeekdays.length > 0) {
      const now = new Date();
      const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      var calDate = new Date(date.year, date.month - 1, date.day).getTime();
      if (element.isLineSDM && !this.isWeekend(date) && calDate >= todayDate) {
        var delDate = new Date(element.defaultDeliveryDate).getTime();

        if (calDate === delDate) {
          requestDateType = element.itemNumber + '_earliestSchDelDate';
        }
        else if (calDate === todayDate && calDate !== delDate) {
          requestDateType = element.itemNumber + '_earliestUnschDelDate';
        }
        else if (calDate > delDate) {
          // Calculate the next earliest delivery day based on selectedWeekdays
          const nextEarliestDate = this.getNextEarliestWeekday(new Date(element.defaultDeliveryDate), this.selectedWeekdays);
          if (calDate === nextEarliestDate.getTime()) {
            requestDateType = element.itemNumber + '_nextEarliestSchDelDate';
          }
          else {
            // Check if calDate is NOT one of the selectedWeekdays
            const earliestUnschDate = this.getEarliestUnscheduledDay(new Date(todayDate), this.selectedWeekdays);
            if (calDate === earliestUnschDate.getTime()) {
              requestDateType = element.itemNumber + '_earliestUnschDelDate';
            }
          }
        }
      }
    }
    
    return requestDateType;
  }

  getNextEarliestWeekday(startDate: Date, selectedWeekdays: number[]): Date {
    const resultDate = new Date(startDate);
    let currentDay = resultDate.getDay() === 0 ? 7 : resultDate.getDay(); // Sunday = 7, others 1-6

    // If startDate is already one of the selected weekdays, move to the next occurrence
    if (selectedWeekdays.includes(currentDay)) {
      resultDate.setDate(resultDate.getDate() + 1); // Move past current day
    }

    // Keep adding days until we hit a selected weekday
    while (true) {
      currentDay = resultDate.getDay() === 0 ? 7 : resultDate.getDay();
      if (selectedWeekdays.includes(currentDay)) {
        break; // Found the next valid weekday
      }
      resultDate.setDate(resultDate.getDate() + 1);
    }

    return resultDate;
  }

  getEarliestUnscheduledDay(startDate: Date, selectedWeekdays: number[]): Date {
    const resultDate = new Date(startDate.getTime());
    while (true) {
      const day = resultDate.getDay() === 0 ? 7 : resultDate.getDay();
      if (!selectedWeekdays.includes(day)) {
        break;
      }
      resultDate.setDate(resultDate.getDate() + 1);
    }
    return resultDate;
  }

  isAnyLineSMDSelected() {
    const sdmLines = this.cppProductItemsDataSource.data.filter(x => x.isSelected == true && x.isLineSDM == true);
    if (this.sdmSystemGeneratedDate == null && sdmLines && sdmLines.length > 0) {
      this.sdmSystemGeneratedDate = new Date(sdmLines[0].defaultDeliveryDate);
    }
    return sdmLines && sdmLines.length > 0;
  }

  dateClass(element) {
    return (dDate: Date): MatCalendarCellCssClasses => {
      const todayDate = new Date();
      if (element.isLineSDM) {
        if (this.sdmSystemGeneratedDate == null) {
          this.sdmSystemGeneratedDate = new Date(element.defaultDeliveryDate);
        }

        const ngDate: NgbDate = new NgbDate(dDate.getFullYear(), dDate.getMonth() + 1, dDate.getDate());
        if (this.calendar.getWeekday(ngDate) < 7
          && dDate >= this.sdmSystemGeneratedDate) {
          if (this.selectedWeekdays.includes(this.calendar.getWeekday(ngDate))) {
            return 'holiday';
          }
          else {
            return 'mat-weekdays';
          }
        }
        else if (dDate >= todayDate
          && this.calendar.getWeekday(ngDate) < 7) {
          return 'mat-weekdays';
        }
        else {
          return undefined;
        }
      }
      else {
        return undefined;
      }
    };
  }

  reasonCodeChange(element) {
    this.cppProductItemsDataSource.data.forEach(item => {
      // update reason code if delivery dates are same
      if (item.rowId != element.rowId && item.isLineSDM
        && new Date(item.deliveryDate).getTime() == new Date(element.deliveryDate).getTime()) {
        item.deliveryDateReason = element.deliveryDateReason;
        this.validateLineItem(item);
      }
    })
    this.validateLineItem(element);
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  onOpen(element) {
    const datepicker = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;

    if (datepicker) {
      this.renderer.addClass(datepicker, 'adjustSpacing');
    }

    if (element.isLineSDM) {
      setTimeout(() => { this.appendFooter(); }, 0);
    }
  }

  appendFooter() {
    const matCalendar = document.getElementsByClassName('mat-datepicker-content')[0] as HTMLElement;
    matCalendar.appendChild(this.datepickerFooter.nativeElement);
  }

  validateRequestDeliveryDateFilter(data: any) {
    const currentDate = new Date();
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.config.maxDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 7, day: currentDate.getDate() };

    if (data.deliveryDate) {
      const fDate = new Date(data.deliveryDate);
      this.requestDatemodel = { year: fDate.getFullYear(), month: fDate.getMonth() + 1, day: fDate.getDate() };

    }
    else {
      this.requestDatemodel = null;
    }
  }

  onDateSelect(date: NgbDate, item: any) {
    item.openDatepicker = false;
    var delDate;
    if (date == null) {
      delDate = new Date();
    }
    else {
      delDate = new Date(date.year, date.month - 1, date.day);
    }

    item.deliveryDate = this.datePipe.transform(delDate, 'MM/dd/yyyy');
    this.validateDate(item);
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  openCalendar(element: any) {
    setTimeout(() => {
      this.validateRequestDeliveryDateFilter(element);
      element.openDatepicker = true;
    }, 100);
  }
  
  closeCalendar(element: any, event?: MouseEvent) {
    // Delay removal slightly to ensure Angular updates the DOM
    setTimeout(() => {
        event?.stopPropagation();
        element.openDatepicker = false;
    }, 100);
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  // Create new row on Additional Request button Click
  CreateNewRow(element) {
    const addNewRow = JSON.parse(JSON.stringify(element));
    const orderList = [];
    let currRow = 1;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { additionalRequestDateRow: true });
    this.cppProductItemsDataSource.data.forEach(x => {
      if (currRow == element.rowId) {
        let count = this.cppProductItemsDataSource.data.filter(x => x.itemNumber === addNewRow.itemNumber).length;
        if (count < parseInt(this.bulkItemNumberOfLine)) {
          x.isBulkSetup = false;
          orderList.push(x);

          currRow = currRow + 1;
          addNewRow.rowId = currRow;
          addNewRow.isSelected = false;
          addNewRow.deliveryDate = null;
          addNewRow.quantity = 1;
          addNewRow.lineErrors.errors = [];
          count = count + 1;
          if (count == parseInt(this.bulkItemNumberOfLine)) {
            addNewRow.isBulkRowExceed = true;
          }
          orderList.push(addNewRow);
        }
      }
      else {
        x.rowId = currRow;
        orderList.push(x);
      }
      currRow = currRow + 1;
    });

    this.filteredDataCount = orderList.length;
    this.cppProductItemsDataSource.data = orderList;
    this.cppOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.enablePlaceOrderAndSaveOrderDraft();
  }

  // Update Additional Request Row logic on Edit order and delete row
  updateAdditionalRequest() {
    const orderList = [];
    const itemData = [];

    this.cppProductItemsDataSource.data.forEach(x => {
      if (x.bulkPackaged == 'BULK') {
        const count = this.cppProductItemsDataSource.data.filter(x1 => x1.itemNumber === x.itemNumber && x.bulkPackaged == 'BULK').length;

        if (itemData.filter(x1 => x1.itemNumber === x.itemNumber).length > 0) {
          itemData.forEach(x => {
            x.currentState = x.currentState + 1;
          });
        } else {
          const item = {
            'itemNumber': x.itemNumber,
            'count': count,
            'currentState': 1
          };
          itemData.push(item);
        }

        const bulkItem = itemData.filter(x1 => x1.itemNumber === x.itemNumber)[0];

        if (bulkItem.currentState == parseInt(this.bulkItemNumberOfLine)) {
          x.isBulkSetup = true;
          x.isBulkRowExceed = true;
          orderList.push(x);
        } else if (bulkItem.currentState == count) {
          x.isBulkSetup = true;
          x.isBulkRowExceed = false;
          orderList.push(x);
        } else {
          x.isBulkSetup = false;
          x.isBulkRowExceed = false;
          orderList.push(x);
        }
      } else {
        orderList.push(x);
      }
    });

    this.filteredDataCount = orderList.length;
    this.cppProductItemsDataSource.data = orderList;
    this.cppOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
  }

  // Update the data after delete the selected row
  deleteSelectedAccount() {
    const orderList = [];
    let currRow = 1;
    this.cppProductItemsDataSource.data.forEach(x => {
      if (x.isSelected == true) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
        this.selectedCount = this.selectedCount - 1;
        x.isSelected = false;
      }
      else {
        x.rowId = currRow;
        orderList.push(x);
        currRow = currRow + 1;
      }
    });

    if (orderList.length < 1) {
      this.disablecheckbox = true;
    }
    this.filteredDataCount = orderList.length;
    this.cppProductItemsDataSource.data = orderList;
    this.cppOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.enablePlaceOrderAndSaveOrderDraft();

    this.updateAdditionalRequest();
  }

  convertFirstWordToUpperCase(str) {
    const arr = str.split(' ');
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const finalstring = arr.join(' ');
    this.blkContactName = finalstring;
  }

}
class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
